import {
	AppBar,
	Dialog,
	IconButton,
	Toolbar,
	WithStyles,
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Collapse from '@material-ui/core/Collapse';
import grey from '@material-ui/core/colors/grey';
import ListItem from '@material-ui/core/ListItem';
import Paper from '@material-ui/core/Paper';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import ChevronRight from '@material-ui/icons/ChevronRight';
import CloseIcon from '@material-ui/icons/Close';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { StaticContext } from 'react-router';
import { RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';
import { isMobile } from '../utils/MobileCheck';

import { UpwardTransition } from 'src/utils';

import {
	setCurriculumDetail,
	setCurriculumDetailDialog,
} from '../actions/search';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
import ScenarioFactory from '../scenario/SearchScenarioFactory';
import { Routes, Screens } from '../utils/Routes';
import CurriculumAchieveCondition from './CurriculumAchieveCondition';

const styles = (theme: Theme) =>
	createStyles({
		appBar: {
			position: 'relative',
			width: 'auto',
		},
		button: {
			margin: '10px',
		},
		careerDialog: {
			width: '80%',
		},
		cellItemName: {
			backgroundColor: grey[300],
			minWidth: '180px',
			textAlign: 'right',
			width: '20%',
		},
		cellItemValue: {
			textAlign: 'left',
			width: '80%',
		},
		flex: {
			flex: 1,
		},
		headerName: {
			backgroundColor: grey[300],
		},
		link: {
			color: 'blue',
			cursor: 'pointer',
		},
		listItem: {
			backgroundColor: '#CDE3ED',
			borderRadius: '5px',
			marginBottom: '2px',
		},
		mobileCellItemName: {
			alignItems: 'center',
			backgroundColor: grey[300],
			display: 'flex',
			minHeight: '40px',
			minWidth: '10px',
			paddingLeft: '5px',
			textAlign: 'left',
			whiteSpace: 'normal',
			width: '100%',
			wordBreak: 'break-all',
		},
		mobileCellItemValue: {
			alignItems: 'center',
			display: 'flex',
			minHeight: '40px',
			paddingLeft: '5px',
			textAlign: 'left',
			whiteSpace: 'normal',
			width: '100%',
			wordBreak: 'break-all',
		},
		mobileFlex: {
			flex: 1,
			fontSize: '16px',
		},
		mobileTable: {
			minWidth: '100px',
		},
		paper: {
			overflowX: 'auto',
		},
		root: {
			flexGrow: 1,
			padding: 18,
		},
		scrollPaper: {
			alignItems: 'flex-start',
		},
		table: {
			minWidth: '700px',
		},
		wrapDiv: {
			margin: '10px',
		},
		wrapDivButton: {
			alignItems: 'center',
			justifyContent: 'center',
			margin: '10px',
		},
	});

interface IRouteParams {
	curriculum_id: string;
}

// tslint:disable-next-line: no-empty-interface
interface IRouteState {}

interface IState {
	curriculumInfoOpen: boolean;
	detailInfoOpen: boolean;
	hrInfoOpen: boolean;
}

/**
 * カリキュラム情報詳細
 */
class CurriculumDetail extends React.Component<IProps, IState> {
	public constructor(props: IProps) {
		super(props);

		if (this.props.curriculumId) {
			this.props.fetchCurriculumDetail(
				this.props.curriculumId,
				this.props.token
			);
		}

		this.state = {
			curriculumInfoOpen: false,
			detailInfoOpen: false,
			hrInfoOpen: false,
		};

		this.showCurriculumAchieveCondition = this.showCurriculumAchieveCondition.bind(
			this
		);
		this.curriculumToggleTree = this.curriculumToggleTree.bind(this);
		this.detailToggleTree = this.detailToggleTree.bind(this);
		this.hrToggleTree = this.hrToggleTree.bind(this);
	}

	/**
	 * Lifecycle Methods
	 */
	public componentDidMount() {
		window.scrollTo({
			top: 0,
		});
		if (!this.props.match || !this.props.match.params) {
			return;
		}

		const curriculumId = this.props.match.params.curriculum_id;

		// データ取得処理
		this.props.fetchCurriculumDetail(curriculumId, this.props.token);
	}

	/**
	 * Lifecycle Methods
	 */
	public componentWillUnmount() {
		// データを破棄
		this.props.resetCurriculumDetail();
	}

	public render() {
		const { classes, curriculumInfo, showHRAttribute } = this.props;
		const { reference, referenceUrl } = curriculumInfo;

		// 参考
		let referenceElm;
		if (referenceUrl && referenceUrl !== '') {
			referenceElm = (
				<span
					className={classes.link}
					data-url={referenceUrl}
					onClick={this.onClickOpenTab}
				>
					{reference}
				</span>
			);
		} else {
			referenceElm = reference;
		}

		return (
			<div className={classes.root}>
				<div className={classes.wrapDiv}>
					{isMobile() && (
						<>
							<ListItem className={classes.listItem}>
								{this.state.curriculumInfoOpen ? (
									<ExpandMore />
								) : (
									<ChevronRight />
								)}
								<Typography
									variant="h6"
									color="inherit"
									className={classes.mobileFlex}
									onClick={this.curriculumToggleTree}
								>
									{i18n.t('CurriculumDetail_0001')}
								</Typography>
							</ListItem>
							<Paper className={classes.paper}>
								<div className={classes.mobileTable}>
									<div className={classes.mobileCellItemName}>
										{i18n.t('CurriculumDetail_0002')}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										{curriculumInfo.careerName}
									</div>
									<div className={classes.mobileCellItemName}>
										{i18n.t('CurriculumDetail_0003')}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										{curriculumInfo.careerId}
									</div>
									<Collapse
										in={this.state.curriculumInfoOpen}
										timeout="auto"
										unmountOnExit={true}
									>
										<div
											className={
												classes.mobileCellItemName
											}
										>
											{i18n.t('CurriculumDetail_0004')}
										</div>
										<div
											className={
												classes.mobileCellItemValue
											}
										>
											{curriculumInfo.managementCode}
										</div>
									</Collapse>
								</div>
							</Paper>
						</>
					)}
					{!isMobile() && (
						<>
							<Typography
								variant="h6"
								color="inherit"
								className={classes.flex}
							>
								{i18n.t('CurriculumDetail_0001')}
							</Typography>
							<Paper className={classes.paper}>
								<Table className={classes.table}>
									<TableBody>
										<TableRow>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t(
													'CurriculumDetail_0002'
												)}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{curriculumInfo.careerName}
											</TableCell>
										</TableRow>
										<TableRow>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t(
													'CurriculumDetail_0003'
												)}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{curriculumInfo.careerId}
											</TableCell>
										</TableRow>
										<TableRow>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t(
													'CurriculumDetail_0004'
												)}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{curriculumInfo.managementCode}
											</TableCell>
										</TableRow>
									</TableBody>
								</Table>
							</Paper>
						</>
					)}
				</div>
				<div className={classes.wrapDiv}>
					{isMobile() && (
						<>
							<ListItem className={classes.listItem}>
								{this.state.detailInfoOpen ? (
									<ExpandMore />
								) : (
									<ChevronRight />
								)}
								<Typography
									variant="h6"
									color="inherit"
									className={classes.mobileFlex}
									onClick={this.detailToggleTree}
								>
									{i18n.t('CurriculumDetail_0005')}
								</Typography>
							</ListItem>
							<Paper className={classes.paper}>
								<div className={classes.mobileTable}>
									<div className={classes.mobileCellItemName}>
										{i18n.t('CurriculumDetail_0006')}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										{curriculumInfo.purpose}
									</div>
									<div className={classes.mobileCellItemName}>
										{i18n.t('CurriculumDetail_0007')}
									</div>
									<div
										className={classes.mobileCellItemValue}
									>
										{curriculumInfo.outline}
									</div>
									<Collapse
										in={this.state.detailInfoOpen}
										timeout="auto"
										unmountOnExit={true}
									>
										<div
											className={
												classes.mobileCellItemName
											}
										>
											{i18n.t('CurriculumDetail_0008')}
										</div>
										<div
											className={
												classes.mobileCellItemValue
											}
										>
											{curriculumInfo.organizer}
										</div>
										<div
											className={
												classes.mobileCellItemName
											}
										>
											{i18n.t('CurriculumDetail_0009')}
										</div>
										<div
											className={
												classes.mobileCellItemValue
											}
										>
											{curriculumInfo.credit}
										</div>
										<div
											className={
												classes.mobileCellItemName
											}
										>
											{i18n.t('CurriculumDetail_0010')}
										</div>
										<div
											className={
												classes.mobileCellItemValue
											}
										>
											{curriculumInfo.division}
										</div>
										<div
											className={
												classes.mobileCellItemName
											}
										>
											{i18n.t('CurriculumDetail_0011')}
										</div>
										<div
											className={
												classes.mobileCellItemValue
											}
										>
											{referenceElm}
										</div>
										<div
											className={
												classes.mobileCellItemName
											}
										>
											{i18n.t('CurriculumDetail_0012')}
										</div>
										<div
											className={
												classes.mobileCellItemValue
											}
										>
											{curriculumInfo.target}
										</div>
										<div
											className={
												classes.mobileCellItemName
											}
										>
											{i18n.t('CurriculumDetail_0013')}
										</div>
										<div
											className={
												classes.mobileCellItemValue
											}
										>
											{curriculumInfo.comment}
										</div>
									</Collapse>
								</div>
							</Paper>
						</>
					)}
					{!isMobile() && (
						<>
							<Typography
								variant="h6"
								color="inherit"
								className={classes.flex}
							>
								{i18n.t('CurriculumDetail_0005')}
							</Typography>
							<Paper className={classes.paper}>
								<Table className={classes.table}>
									<TableBody>
										<TableRow>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t(
													'CurriculumDetail_0006'
												)}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{curriculumInfo.purpose}
											</TableCell>
										</TableRow>
										<TableRow>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t(
													'CurriculumDetail_0007'
												)}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{curriculumInfo.outline}
											</TableCell>
										</TableRow>
										<TableRow>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t(
													'CurriculumDetail_0008'
												)}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{curriculumInfo.organizer}
											</TableCell>
										</TableRow>
										<TableRow>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t(
													'CurriculumDetail_0009'
												)}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{curriculumInfo.credit}
											</TableCell>
										</TableRow>
										<TableRow>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t(
													'CurriculumDetail_0010'
												)}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{curriculumInfo.division}
											</TableCell>
										</TableRow>
										<TableRow>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t(
													'CurriculumDetail_0011'
												)}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{referenceElm}
											</TableCell>
										</TableRow>
										<TableRow>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t(
													'CurriculumDetail_0012'
												)}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{curriculumInfo.target}
											</TableCell>
										</TableRow>
										<TableRow>
											<TableCell
												className={classes.cellItemName}
											>
												{i18n.t(
													'CurriculumDetail_0013'
												)}
											</TableCell>
											<TableCell
												className={
													classes.cellItemValue
												}
											>
												{curriculumInfo.comment}
											</TableCell>
										</TableRow>
									</TableBody>
								</Table>
							</Paper>
						</>
					)}
				</div>
				{showHRAttribute === 'Y' && (
					<div className={classes.wrapDiv}>
						{isMobile() && (
							<>
								<ListItem className={classes.listItem}>
									{this.state.hrInfoOpen ? (
										<ExpandMore />
									) : (
										<ChevronRight />
									)}
									<Typography
										variant="h6"
										color="inherit"
										className={classes.mobileFlex}
										onClick={this.hrToggleTree}
									>
										{i18n.t('CurriculumDetail_0014')}
									</Typography>
								</ListItem>
								<Paper className={classes.paper}>
									<div className={classes.mobileTable}>
										<div
											className={
												classes.mobileCellItemName
											}
										>
											{i18n.t('CurriculumDetail_0015')}
										</div>
										<div
											className={
												classes.mobileCellItemValue
											}
										>
											{curriculumInfo.targetOfficeName}
										</div>
										<div
											className={
												classes.mobileCellItemName
											}
										>
											{i18n.t('CurriculumDetail_0016')}
										</div>
										<div
											className={
												classes.mobileCellItemValue
											}
										>
											{curriculumInfo.targetOrganizeName}
										</div>
										<Collapse
											in={this.state.hrInfoOpen}
											timeout="auto"
											unmountOnExit={true}
										>
											<div
												className={
													classes.mobileCellItemName
												}
											>
												{i18n.t(
													'CurriculumDetail_0017'
												)}
											</div>
											<div
												className={
													classes.mobileCellItemValue
												}
											>
												{curriculumInfo.targetPostName}
											</div>
											<div
												className={
													classes.mobileCellItemName
												}
											>
												{i18n.t(
													'CurriculumDetail_0018'
												)}
											</div>
											<div
												className={
													classes.mobileCellItemValue
												}
											>
												{
													curriculumInfo.targetOccupationName
												}
											</div>
											<div
												className={
													classes.mobileCellItemName
												}
											>
												{i18n.t(
													'CurriculumDetail_0019'
												)}
											</div>
											<div
												className={
													classes.mobileCellItemValue
												}
											>
												{
													curriculumInfo.targetEmployeeDivisionName
												}
											</div>
											<div
												className={
													classes.mobileCellItemName
												}
											>
												{i18n.t(
													'CurriculumDetail_0020'
												)}
											</div>
											<div
												className={
													classes.mobileCellItemValue
												}
											>
												{
													curriculumInfo.targetYoungWorker
												}
											</div>
										</Collapse>
									</div>
								</Paper>
							</>
						)}
						{!isMobile() && (
							<>
								<Typography
									variant="h6"
									color="inherit"
									className={classes.flex}
								>
									{i18n.t('CurriculumDetail_0014')}
								</Typography>
								<Paper className={classes.paper}>
									<Table className={classes.table}>
										<TableBody>
											<TableRow>
												<TableCell
													className={
														classes.cellItemName
													}
												>
													{i18n.t(
														'CurriculumDetail_0015'
													)}
												</TableCell>
												<TableCell
													className={
														classes.cellItemValue
													}
												>
													{
														curriculumInfo.targetOfficeName
													}
												</TableCell>
											</TableRow>
											<TableRow>
												<TableCell
													className={
														classes.cellItemName
													}
												>
													{i18n.t(
														'CurriculumDetail_0016'
													)}
												</TableCell>
												<TableCell
													className={
														classes.cellItemValue
													}
												>
													{
														curriculumInfo.targetOrganizeName
													}
												</TableCell>
											</TableRow>
											<TableRow>
												<TableCell
													className={
														classes.cellItemName
													}
												>
													{i18n.t(
														'CurriculumDetail_0017'
													)}
												</TableCell>
												<TableCell
													className={
														classes.cellItemValue
													}
												>
													{
														curriculumInfo.targetPostName
													}
												</TableCell>
											</TableRow>
											<TableRow>
												<TableCell
													className={
														classes.cellItemName
													}
												>
													{i18n.t(
														'CurriculumDetail_0018'
													)}
												</TableCell>
												<TableCell
													className={
														classes.cellItemValue
													}
												>
													{
														curriculumInfo.targetOccupationName
													}
												</TableCell>
											</TableRow>
											<TableRow>
												<TableCell
													className={
														classes.cellItemName
													}
												>
													{i18n.t(
														'CurriculumDetail_0019'
													)}
												</TableCell>
												<TableCell
													className={
														classes.cellItemValue
													}
												>
													{
														curriculumInfo.targetEmployeeDivisionName
													}
												</TableCell>
											</TableRow>
											<TableRow>
												<TableCell
													className={
														classes.cellItemName
													}
												>
													{i18n.t(
														'CurriculumDetail_0020'
													)}
												</TableCell>
												<TableCell
													className={
														classes.cellItemValue
													}
												>
													{
														curriculumInfo.targetYoungWorker
													}
												</TableCell>
											</TableRow>
										</TableBody>
									</Table>
								</Paper>
							</>
						)}
					</div>
				)}
				<div className={classes.wrapDivButton}>
					<Button
						className={classes.button}
						variant="contained"
						color="default"
						onClick={this.showCurriculumAchieveCondition}
					>
						{i18n.t('CurriculumDetail_0021')}
					</Button>
				</div>
				<Dialog
					fullScreen={false}
					TransitionComponent={UpwardTransition}
					open={this.props.openCurriculumDialog}
					onClose={this.handlecloseDetailDialog}
					fullWidth={true}
					maxWidth={false}
					classes={{
						paperFullWidth: this.props.classes.careerDialog,
						scrollPaper: this.props.classes.scrollPaper,
					}}
				>
					<AppBar className={this.props.classes.appBar}>
						<Toolbar>
							<IconButton
								color="inherit"
								aria-label="Close"
								onClick={this.handlecloseDetailDialog}
							>
								<CloseIcon />
							</IconButton>
							<Typography variant="h6" color="inherit">
								{i18n.t('CurriculumDetail_0022')}
							</Typography>
						</Toolbar>
					</AppBar>
					<CurriculumAchieveCondition
						curriculumId={this.props.curriculumId}
					/>
				</Dialog>
			</div>
		);
	}

	/**
	 * 別ウィンドウオープンハンドラ
	 * @param e
	 */
	protected onClickOpenTab(e: React.MouseEvent<HTMLElement>) {
		const url = e.currentTarget.getAttribute('data-url');
		if (url && url !== '') {
			window.open(url, '_blank');
		}
	}

	protected curriculumToggleTree(e: React.MouseEvent<HTMLElement>) {
		this.setState({ curriculumInfoOpen: !this.state.curriculumInfoOpen });
	}

	protected detailToggleTree(e: React.MouseEvent<HTMLElement>) {
		this.setState({ detailInfoOpen: !this.state.detailInfoOpen });
	}

	protected hrToggleTree(e: React.MouseEvent<HTMLElement>) {
		this.setState({ hrInfoOpen: !this.state.hrInfoOpen });
	}

	/**
	 * 達成条件クリックハンドラ
	 * @param e
	 */
	protected showCurriculumAchieveCondition(e: React.MouseEvent<HTMLElement>) {
		const { curriculumInfo, curriculumId } = this.props;
		if (curriculumId) {
			this.props.setCurriculumDetailDialog(true);
		} else {
			if (curriculumInfo.careerId) {
				let to = Routes.getPath(
					Screens.PERSONAL_CURRICULUM_ACHIEVE_CONDITION
				);
				to = to.replace(
					/\/:curriculum_id/,
					`/${curriculumInfo.careerId}`
				);
				this.props.pushHistory(to);
			}
		}
	}

	protected handlecloseDetailDialog = () => {
		this.props.setCurriculumDetailDialog(false);
	};
}

const mapStateToProps = (state: IRootState) => ({
	curriculumInfo: state.search.curriculum.curriculumInfo,
	openCurriculumDialog: state.search.OpenCurriculumDetailDialog,
	showHRAttribute: state.search.curriculum.showHRAttribute,
	token: state.session.token,
	userAttr: state.session.userAttr,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	fetchCurriculumDetail: (curriculumId: string, token: string) => {
		const s = ScenarioFactory.createFetchCurriculumDetail(dispatch, token);
		s.run(curriculumId);
	},
	pushHistory: (path: string) => dispatch(push(path)),
	resetCurriculumDetail: () =>
		dispatch(
			setCurriculumDetail({ curriculumInfo: {}, showHRAttribute: '' })
		),
	setCurriculumDetailDialog: (OpenCurriculumDetailDialog: boolean) =>
		dispatch(setCurriculumDetailDialog({ OpenCurriculumDetailDialog })),
});

export interface ICurriculumDetailProps {
	curriculumId: string;
}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> &
	RouteComponentProps<IRouteParams, StaticContext, IRouteState> &
	ICurriculumDetailProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(CurriculumDetail);

const Styled = withStyles(styles)(Connected);
const Export: React.ComponentType<ICurriculumDetailProps> = Styled;

export default Export;



// WEBPACK FOOTER //
// ./src/containers/CurriculumDetail.tsx